import type { EpcProjectTeamRole } from '../../../../services/epcProjectService';

const GOVERNANCE: EpcProjectTeamRole[] = ['epc_head', 'pmo', 'project_head', 'project_coordinator'];

/**
 * Everything still missing before the Add-Member drawer can submit.
 * Mirrors the backend contract exactly:
 * - governance roles: user only (reportsTo optional)
 * - department_head: user + dept(s) + governance reportsTo
 * - manager: user + dept(s) (head auto-resolves per department)
 * - site_engineer: user + EXACTLY ONE dept (backend allows one SE membership
 *   per project) + the manager they report to
 */
export function addMemberBlockers(input: {
  role: EpcProjectTeamRole;
  userId: string;
  orgIds: string[];
  reportsTo: string;
}): string[] {
  const { role, userId, orgIds, reportsTo } = input;
  const blockers: string[] = [];

  if (!userId) blockers.push('Pick a user');
  if (GOVERNANCE.includes(role)) return blockers;

  if (role === 'site_engineer') {
    if (orgIds.length === 0) blockers.push('Select a department');
    else if (orgIds.length > 1) blockers.push('Site engineers can be added to one department at a time');
    if (orgIds.length <= 1 && !reportsTo) blockers.push('Select which manager this engineer reports to');
    return blockers;
  }

  if (orgIds.length === 0) blockers.push('Select at least one department');
  if (role === 'department_head' && !reportsTo) blockers.push('Select who this person reports to');
  return blockers;
}
